// 🔧 created by ChatGPT on 2025-10-18 – Profile store for non-auth user prefs (avatar, theme, etc.). Persists separately.
import { create } from "zustand";

const LS_KEY = "klmn_profile_v1";

const loadFromStorage = () => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export const useProfileStore = create((set, get) => ({
  // --- state ---
  profile: loadFromStorage() || {
    photoURL: null,
    displayName: "",
    theme: "light",
    // add more profile prefs as needed
  },

  // --- actions ---
  setProfile: (profile) => {
    set({ profile });
    try { localStorage.setItem(LS_KEY, JSON.stringify(profile)); } catch {}
  },

  updateProfile: (patch) => {
    const next = { ...get().profile, ...patch };
    set({ profile: next });
    try { localStorage.setItem(LS_KEY, JSON.stringify(next)); } catch {}
  },

  resetProfile: () => {
    const empty = { photoURL: null, displayName: "", theme: "light" };
    set({ profile: empty });
    try { localStorage.setItem(LS_KEY, JSON.stringify(empty)); } catch {}
  },
}));

export default useProfileStore;
